function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenCloseToggle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.32 29.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.46,3.24,25.72,16.49a1.49,1.49,0,0,1,0,2.12L12.46,31.87a1.49,1.49,0,0,1-2.12,0L9.28,30.81a1.5,1.5,0,0,1,0-2.12L19.36,18.62a1.52,1.52,0,0,0,0-2.13L9.28,6.42a1.49,1.49,0,0,1,0-2.12l1.06-1.07A1.5,1.5,0,0,1,12.46,3.24Z",
    transform: "translate(-8.84 -2.8)",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCloseToggle2);
export default __webpack_public_path__ + "static/media/OpenCloseToggle2.aa1294a117ab4e105cfecb46a052178c.svg";
export { ForwardRef as ReactComponent };